<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">全体アラート</li>
            </ol>
        </nav>
        <div class="container">
            <div class="mb-3">
                <div class="text-pane">
                    <div class="text-pane-dummy">{{message + '\u200b'}}</div>
                    <textarea class="text-pane-editor"
                        v-model="message"
                        @keydown.ctrl.enter="alert()"
                        @keydown.meta.enter="alert()"
                        placeholder="アクティブユーザーに配信するメッセージ"></textarea>
                </div>
            </div>
            <div class="mb-3 row">
                <div class="col-md-6">
                    <div class="btn-group">
                        <label class="btn btn-outline-success" :class="{active: type == 'msg'}">
                            <input type="radio" v-model="type" value="msg" class="d-none">
                            <i class="fas fa-check-circle" v-if="type == 'msg'"></i>
                            <i class="far fa-circle" v-else></i>
                            通常
                        </label>
                        <label class="btn btn-outline-warning" :class="{active: type == 'warn'}">
                            <input type="radio" v-model="type" value="warn" class="d-none">
                            <i class="fas fa-check-circle" v-if="type == 'warn'"></i>
                            <i class="far fa-circle" v-else></i>
                            注意
                        </label>
                        <label class="btn btn-outline-danger" :class="{active: type == 'err'}">
                            <input type="radio" v-model="type" value="err" class="d-none">
                            <i class="fas fa-check-circle" v-if="type == 'err'"></i>
                            <i class="far fa-circle" v-else></i>
                            警告
                        </label>
                    </div>
                </div>
                <div class="col-md-6 text-right">
                    <button class="btn btn-outline-primary" @click="alert()" :disabled="!message">
                        <i class="far fa-comment-dots"></i>
                        配信
                    </button>
                </div>
            </div>
            <div class="mb-3">
                <ul>
                    <li>現在アクセス中のアクティブユーザーにメッセージを即時配信します。</li>
                    <li>メッセージはalert機能で右上に表示されます。</li>
                    <li>アクティブユーザーは非登録ユーザーも含まれます。</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.container {
    max-width: 640px;
}
.text-pane {
    position: relative;
    letter-spacing: 1px;
    border: 0px;
    border-radius: 4px;
    margin: 0 auto .5rem;
    .text-pane-dummy {
        overflow: hidden;
        font-size: 1rem;
        line-height: 2rem;
        box-sizing: border-box;
        padding: .5rem 1rem;
        min-height: 120px;
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
        letter-spacing: 1px;
        border: 0;
        border-radius: 4px;
        opacity: 0;
    }
    .text-pane-editor {
        position: absolute;
        top: 0;
        left: 0;
        font-size: 1rem;
        line-height: 2rem;
        letter-spacing: 1px;
        display: block;
        overflow: hidden;
        box-sizing: border-box;
        padding: .5rem 1rem;
        width: 100%;
        height: 100%;
        border: 0;
        resize: none;
        &:focus {
            outline: none;
        }
        border-radius: 4px;
    }
}
</style>
<script>
export default {
    data() {
        return {
            message: "",
            type: "msg",
        }
    },
    methods: {
        alert() {
            axios.post("/admin/alert/message", {
                type: this.type,
                message: this.message,
            }).then(res => {
                this.message = "";
            }).catch(err => { alert.err(err) });
        }
    },
}
</script>